import React from 'react';
import { useDispatch } from 'react-redux';
import { setIsCreateModalOpen, setSearchField } from 'src/store/updateShiftsPageSlice';
import Row from '@amzn/meridian/row';
import { useAppSelector } from 'src/store/store';
import SearchField from '@amzn/meridian/search-field';
import Button from '@amzn/meridian/button';

const TopOptions = () => {
  const dispatch = useDispatch();
  const { searchField } = useAppSelector((state) => state.updateShiftsPage);

  return (
    <Row widths={['85%', '15%']} spacingInset="400 none" alignmentHorizontal="justify">
      <Row width={'grid-4'}>
        <SearchField
          value={searchField}
          onChange={(newSearchField) => dispatch(setSearchField(newSearchField))}
          placeholder="Search for..."
          onSubmit={() => {}}
        />
      </Row>
      <Button className="view-and-edit-tasks__open-modal" onClick={() => dispatch(setIsCreateModalOpen(true))}>
        Create Shift
      </Button>
    </Row>
  );
};

export default TopOptions;
